import React from "react";
import { useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { COMPANY } from "@/lib/api";
import { useOpenStatus, StatusDot } from "@/components/OpenStatus";

const PRODUCT_PAGE = /^\/(mini-pelles|mini-pelles-occasion|pieces-detachees)\/[^/]+/;

export default function FloatingCallButton() {
  const status = useOpenStatus();
  const { pathname } = useLocation();
  if (PRODUCT_PAGE.test(pathname)) return null;
  return (
    <a
      href={`tel:${COMPANY.phoneTel}`}
      data-testid="floating-call-btn"
      aria-label={`Appeler ${COMPANY.phone} — ${status.open ? "ouvert maintenant" : "fermé, laissez un message"}`}
      className="lg:hidden fixed bottom-4 right-4 z-40 w-14 h-14 rounded-full bg-[#072135] text-[#D8B86A] flex items-center justify-center shadow-2xl ring-4 ring-white/70 active:scale-95 transition-transform mb-[env(safe-area-inset-bottom)]"
    >
      <Phone size={22} />
      <StatusDot open={status.open} className="absolute top-1 right-1 ring-2 ring-[#072135] rounded-full" />
      <span className="sr-only" data-testid="floating-call-status">{status.open ? "Ouvert maintenant" : "Fermé · laissez un message"}</span>
    </a>
  );
}
